import { Role } from "./role.model";

export class User {
    // Constants
    static readonly REFERENCE = "user"

    // Attributes
    private avatar_path: string;
    private birthdate: string;
    private birthplace: string;
    private civil_status: string;
    private created_at: string;
    private document_number: string;
    private document_type: string;
    private email: string;
    private gender: string;
    private id: number;
    private is_academic: boolean;
    private name: string;
    private phone: string;
    private residence_address: string;
    private residence_city: string;
    private second_name: string;
    private second_surname: string;
    private surname: string;
    private updated_at: string;

    private role: Role

    // SET & GET
    public set $avatar_path(v: string) { this.avatar_path = v; }
    public set $birthdate(v: string) { this.birthdate = v; }
    public set $birthplace(v: string) { this.birthplace = v; }
    public set $civil_status(v: string) { this.civil_status = v; }
    public set $created_at(v: string) { this.created_at = v; }
    public set $document_number(v: string) { this.document_number = v; }
    public set $document_type(v: string) { this.document_type = v; }
    public set $email(v: string) { this.email = v; }
    public set $gender(v: string) { this.gender = v; }
    public set $is_academic(v: boolean) { this.is_academic = v; }
    public set $name(v: string) { this.name = v; }
    public set $phone(v: string) { this.phone = v; }
    public set $residence_address(v: string) { this.residence_address = v; }
    public set $residence_city(v: string) { this.residence_city = v; }
    public set $second_name(v: string) { this.second_name = v; }
    public set $second_surname(v: string) { this.second_surname = v; }
    public set $surname(v: string) { this.surname = v; }
    public set $updated_at(v: string) { this.updated_at = v; }

    public set $role(v: Role) { this.role = v; }

    public get _avatar_path() { return this.avatar_path; }
    public get _birthdate() { return this.birthdate; }
    public get _birthplace() { return this.birthplace; }
    public get _civil_status() { return this.civil_status; }
    public get _created_at() { return this.created_at; }
    public get _document_number() { return this.document_number; }
    public get _document_type() { return this.document_type; }
    public get _email() { return this.email; }
    public get _id() { return this.id; }
    public get _gender() { return this.gender; }
    public get _is_academic() { return this.is_academic; }
    public get _name() { return this.name; }
    public get _phone() { return this.phone; }
    public get _residence_address() { return this.residence_address; }
    public get _residence_city() { return this.residence_city; }
    public get _second_name() { return this.second_name; }
    public get _second_surname() { return this.second_surname; }
    public get _surname() { return this.surname; }
    public get _updated_at() { return this.updated_at; }

    public get _role() { return this.role; }

    // CONSTRUCTOR
    constructor(info?: NewUser) {
        if (info) {
            this.loadInfo(info)
        }
    }

    loadInfo(info: any) {
        this.avatar_path = this.loadData(info.avatar_path);
        this.birthdate = this.loadData(info.birthdate);
        this.birthplace = this.loadData(info.birthplace);
        this.civil_status = this.loadData(info.civil_status);
        this.created_at = this.loadData(info.created_at);
        this.document_number = this.loadData(info.document_number);
        this.document_type = this.loadData(info.document_type);
        this.email = this.loadData(info.email);
        this.gender = this.loadData(info.gender);
        this.id = this.loadData(info.id);
        this.is_academic = this.loadData(info.is_academic);
        this.name = this.loadData(info.name);
        this.phone = this.loadData(info.phone);
        this.residence_address = this.loadData(info.residence_address);
        this.residence_city = this.loadData(info.residence_city);
        this.second_name = this.loadData(info.second_name);
        this.second_surname = this.loadData(info.second_surname);
        this.surname = this.loadData(info.surname);
        this.updated_at = this.loadData(info.updated_at);

        if(info.roles[0]) {
            this.role = new Role(info.roles[0]);
        }
    }

    serializate(): any {
        return {
            avatar_path: this.avatar_path,
            birthdate: this.birthdate,
            birthplace: this.birthplace,
            civil_status: this.civil_status,
            created_at: this.created_at,
            document_number: this.document_number,
            document_type: this.document_type,
            email: this.email,
            gender: this.gender,
            // id: this.id,
            is_academic: this.is_academic,
            name: this.name,
            phone: this.phone,
            residence_address: this.residence_address,
            residence_city: this.residence_city,
            second_name: this.second_name,
            second_surname: this.second_surname,
            surname: this.surname,
            updated_at: this.updated_at
        }
    }

    /**
     * Para enviar los datos necesarios como json
     * @memberof User
     */
    serializeToNotification(): any {
        return {
            id: this.id,
            name: this._fullname()
        }
    }

    _fullname(): string {
        return `${this.name} ${this.second_name} ${this.surname} ${this.second_surname}`;
    }

    private loadData<T>(data: T, defaul?: T) {
        return data === undefined ?
            defaul !== undefined ? defaul : null : data
    }
}

export interface NewUser {
    id: number,

    birthdate: string,
    birthplace: string,
    civil_status: string,
    created_at: string,
    document_number: string,
    document_type: string,
    email: string,
    gender: string,
    is_academic: boolean,
    name: string,
    phone: string,
    residence_address: string,
    residence_city: string,
    second_name: string,
    second_surname: string,
    surname: string,
    updated_at: string,

    role: Role,

    avatar_path?: string
}



// WEBPACK FOOTER //
// ./src/app/models/user.model.ts